var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bigBox" }, [
    _c("div", { staticClass: "videoContainer" }, [
      _c(
        "video",
        {
          staticClass: "fullscreenVideo",
          attrs: {
            id: "bgVid",
            playsinline: "",
            autoplay: "",
            muted: "",
            loop: "",
          },
          domProps: { muted: true },
        },
        [
          _c("source", {
            attrs: {
              src: require("../../assets/images/loginBgVideo.mp4"),
              type: "video/mp4",
            },
          }),
        ]
      ),
    ]),
    _c("div", { staticClass: "loginArea" }, [
      _c("img", {
        staticStyle: { width: "100%" },
        attrs: { src: require("../../assets/images/loginHead.png") },
      }),
      _c(
        "div",
        { staticStyle: { width: "440px", margin: "auto" } },
        [_c("LoginForm")],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }